import { useMemo } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { ITransactionSetTypes } from 'types/graphqlTypes'
import { useEdiTransactionSetsWithSubtypesQuery } from '../../graphql/EdiTransactionSetsWithSubtypes'
import { encodeOptionValue } from './utils/encodeDecodeOptionValue'
import { formatOptionLabel } from './utils/formatOptionLabel'

// this can be set during UI initial loading, before a builder has been selected.
export const DEFAULT_TRANSACTION_SET = {
  transactionSet: ITransactionSetTypes._990,
  transactionSetSubtype: undefined,
}

export const useTransactionSets = () => {
  const { data: transactionSetData } = useEdiTransactionSetsWithSubtypesQuery()

  // after we receieve the gql query result (containing valid transaction set + subtype pairs)
  // we need to update our list of select options
  const selectOptions: ISelectOption[] = useMemo(() => {
    const options: ISelectOption[] = []

    if (transactionSetData) {
      transactionSetData.ediTransactionSetsWithSubtypes.forEach(item => {
        const label = formatOptionLabel(item)
        const value = encodeOptionValue(item.transactionSet, item.transactionSetSubtype)
        options.push({ label, value })
      })
    }

    return options
  }, [transactionSetData])

  return {
    selectOptions,
  }
}
